import React, { useEffect } from "react";
import Navigation from "../Navigation";
import "../TicketsPage/style.scss";
import ReturnButton from "../../../features/ReturnButton";
import { EXERCISE_PAGE, ZONES_PAGE } from "../../routes";
import { useNavigate } from "react-router";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { REALIZE_VOUCHER } from "../../models/TypeSale";
import LeftContainer from "../TicketsPage/LeftContainer";
import useBasketManager from "../Basket/useBasketManager";
import RealizeVoucher from "./RealizeVoucher";

const RealizeVoucherPage: React.FC = () => {
  const navigate = useNavigate();
  const isDesktop = useDesktopSize();

  const { basket, setBasket, totalListPrice, removeBasket, clearBasket } = useBasketManager(false);

  const navigateToFinalize = () => {
    navigate(`${EXERCISE_PAGE}?isSaleWithExercise=true&typeSale=${REALIZE_VOUCHER}`);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    clearBasket();
    //eslint-disable-next-line
  }, []);

  return (
    <Navigation>
      <div className={"sale-panel"}>
        <div className={"tickets-panel"}>
          <p className={"title"}>Zrealizuj voucher</p>
          <RealizeVoucher updateBasket={setBasket} />
          {isDesktop && <ReturnButton onClick={() => navigate(ZONES_PAGE)} />}
        </div>
        {basket.length > 0 && (
          <LeftContainer
            colorClass={"use-pass-color"}
            basket={basket}
            onRemoveToBasket={removeBasket}
            updateBasket={setBasket}
            onNavigateFinalize={() => navigateToFinalize()}
            finalizeButtonText={"Dalej"}
            isSaleWithExercise={false}
            totalListPrice={totalListPrice}
            isWeatherTicket={false}
            title={"Zrealizuj voucher"}
          />
        )}
      </div>
    </Navigation>
  );
};

export default RealizeVoucherPage;
